import React from 'react';

const BadgeStatus = ({ status, variant, style, ...props }) => {
  const getStatusConfig = () => {
    // Auto-determine variant and label based on status if variant not provided
    if (!variant) {
      switch (status) {
        case 'available':
          return { variant: 'success', label: 'Available' };
        case 'pending':
          return { variant: 'warning', label: 'Pending' };
        case 'in_transfer':
        case 'In Transfer':
          return { variant: 'secondary', label: 'In Transfer' };
        case 'received':
          return { variant: 'info', label: 'Received' };
        case 'issue_reported':
          return { variant: 'danger', label: 'Issue Reported' };
        case 'acknowledged':
          return { variant: 'success', label: 'Acknowledged' };
        case 'rejected':
          return { variant: 'danger', label: 'Rejected' };
        default:
          return { variant: 'info', label: status };
      }
    }

    // If variant is provided, use it and format status label
    const label = status === 'acknowledged' ? 'Acknowledged' :
      status === 'pending' ? 'Pending' :
        status === 'in_transfer' || status === 'In Transfer' ? 'In Transfer' :
          status === 'issue_reported' ? 'Issue Reported' :
            status === 'received' ? 'Received' :
              status === 'rejected' ? 'Rejected' :
                status === 'available' ? 'Available' :
                  status;

    return { variant, label };
  };

  const getVariantStyles = (variantType) => {
    switch (variantType) {
      case 'success':
        return { background: '#c6f6d5', color: '#22543d' };
      case 'warning':
        return { background: '#feebc8', color: '#744210' };
      case 'danger':
        return { background: '#fed7d7', color: '#c53030' };
      case 'secondary':
        return { background: '#ddd6fe', color: '#5b21b6' }; // Purple for in transfer
      case 'info':
        return { background: '#bee3f8', color: '#2c5282' };
      default:
        return { background: '#e2e8f0', color: '#4a5568' };
    }
  };

  const statusConfig = getStatusConfig();
  const styles = getVariantStyles(statusConfig.variant);

  return (
    <span
      className={`badge-status badge-${status}`}
      style={{
        padding: '4px 12px',
        borderRadius: '12px',
        fontSize: '12px',
        fontWeight: 600,
        display: 'inline-block',
        ...styles,
        ...style
      }}
      {...props}
    >
      {statusConfig.label}
    </span>
  );
};

export default BadgeStatus;


